export function isSpecificUser(user, values) {
  if (user && values) {
    for (let i = 0; i < values.length; i++) {
      if (user.get('authority').toLowerCase() === values[i].toLowerCase()) {
        return true;
      }
    }
  }
  return false;
}

export function isSpecificAuthority(authority, values) {
  if (authority && values) {
    for (let i = 0; i < values.length; i++) {
      if (authority.toLowerCase() === values[i].toLowerCase()) {
        return true;
      }
    }
  }
  return false;
}
